import queryString from "query-string";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {lgSetup, validateInSetup} from "../../backend/LgSetup";
import i18next from "i18next";
import {datadogLogs} from "@datadog/browser-logs";

export function getUtmTestParameters() {
    return "skin=1" +
        "&admin=true" +
        "&utm_source=lg" +
        "&utm_campaign=2023EU.Version1.TRAFFIC.Text" +
        "&utm_medium=COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.Ver1" +
        "&utm_content=BELLACIAO_MARIA_VIDEO-TLN2022_12_29" +
        "&utm_brand=brand&lng=ru"

}

export function testUtmParser() {
    let str = getUtmTestParameters()
    let res = {}
    let queryParams = queryString.parse(str)
    parseUtmParams(queryParams, res)
    parseGeneralParams(queryParams, res)
    assertEqual("1", res.skin)
    if (!res.admin)
        throw Error("AdminParsing!")
    assertEqual("lg", res.utm_source)
    assertEqual("2023EU.Version1.TRAFFIC.Text", res.utm_campaign)
    assertEqual("COLD.BADEN-WÜRTTEMBERG.RU.VIOLIN.Ver1", res.utm_medium)
    assertEqual("BELLACIAO_MARIA_VIDEO-TLN2022_12_29", res.utm_content)
    assertEqual("brand", res.utm_brand)
    assertEqual("TRAFFIC", res.cmpTarget)
    assertEqual("2023EU", res.cmpCode)
    assertEqual("Version1", res.cmpVersion)
    assertEqual("COLD", res.setType)
    assertEqual("BADEN-WÜRTTEMBERG", res.geoCode)
    assertEqual("ru", res.setLang)
    assertEqual("VIOLIN", res.setFocusCode)
    assertEqual("Ver1", res.setVersion)
    assertEqual("BELLACIAO_MARIA_VIDEO-TLN2022_12_29", res.adsCode)
}

function parseAndValidateAds(ret) {
    if (false && ret.utm_content !== undefined && ret.utm_content !== null) {
        ret.adsCode = validateInSetup("adss", ret.utm_content.split(".")[0])
        ret.pastEventCode = validateInSetup("pastEvents", ret.adsCode.split("-")[1])
    }
}

function parseAndValidateMedium(ret) {
    if (false && ret.utm_medium !== undefined && ret.utm_medium !== null && ret.utm_medium.split(".").length > 1 ) {
        ret.setType = validateInSetup("audienceTypes", ret.utm_medium.split(".")[0])

        ret.geoCode = ret.utm_medium.split(".")[1]
        let reg = lgSetup.regions[ret.geoCode]
        let city = lgSetup.cities[ret.geoCode]
        if (reg === undefined && city === undefined)
            throw Error("Invalid geo" + ret.geoCode)
        //TODO rename
        if (ret.utm_medium.split(".")[2] === undefined)
            throw Error("Missed language:" + ret.utm_medium)
        ret.setLang = validateInSetup("langs", ret.utm_medium.split(".")[2].toLowerCase())
        //TODO rename
        ret.setFocusCode = validateInSetup("focuses", ret.utm_medium.split(".")[3])
        ret.setVersion = ret.utm_medium.split(".")[4]
        if (ret.setVersion === undefined)
            throw Error("SetVersion not found: " + ret.utm_medium)

    }
}

function parseAndValidateCampaign(ret) {

    if (ret.utm_campaign !== undefined && ret.utm_campaign !== null) {
        ret.cmpCode = ret.utm_campaign.split(".")[0]
        validateInSetup("cmps", ret.cmpCode)
        ret.cmp = lgSetup["cmps"][ret.cmpCode]
        if (ret.utm_campaign.split(".").length > 0) {
            ret.cmpVersion = ret.utm_campaign.split(".")[1]
            if (ret.cmpVersion === undefined)
                throw Error("CmpVersion not found: " + ret.utm_campaign)
            ret.cmpTarget = ret.utm_campaign.split(".")[2]
            if (ret.cmpTarget === undefined)
                throw Error("CmpTarget not found: " + ret.utm_campaign)
            //validateInSetup("targets", ret.cmpTarget)
            let expl = ret.utm_campaign.split(".")[3]
            if (expl === undefined)
                throw Error("Missed description of cm : " + ret.utm_campaign + " format is A.B.D")

        }
    }

}

export function parseUtmParams(params, ret) {

    ret.utm_source = params["utm_source"];
    ret.utm_medium = params["utm_medium"];
    ret.utm_campaign = params["utm_campaign"];
    ret.utm_content = params["utm_content"];
    ret.utm_brand = params["utm_brand"];
    console.log("UTM")
    console.log(ret.utm_campaign)

    try {
        //parseAndValidateCampaign(ret)
        //parseAndValidateMedium(ret)
        //parseAndValidateAds(ret)
    } catch (err) {
        console.log("dd")
        if (window.location.host.includes("local")) {
            throw err
        } else
            datadogLogs.logger.error("UTM:" + err.message, {err})
        console.log("ee")
    }
}

export function parseGeneralParams(params, ret) {
    ret.iframeId = params["frameid"]
    ret.parentPath = params["parentPath"]
    ret.pixel = params["pixel"]
    ret.referenceId = params["referenceId"]
    ret.skin = params["skin"];
    if (ret.skin === undefined || ret.skin === "null")
        ret.skin = "";
    ret.admin = params["admin"];
    ret.abTest1 = params["abTest1"];
    ret.abTest2 = params["abTest2"];
    ret.abTest3 = params["abTest3"];
    ret.priceNote = params["priceNote"];
    ret.external_id = params["external_id"];
    ret.language = i18next.language

    if (ret.language === undefined)
        ret.language = ret.setLang
    if (ret.language === undefined)
        ret.language = "ru"
    //i18next.language = ret.language
}


export function calcUtmString(data) {
    return (data.utm_source !== undefined ? "&utm_source=" + data.utm_source : "") +
        (data.utm_medium !== undefined ? "&utm_medium=" + data.utm_medium : "") +
        (data.utm_campaign !== undefined ? "&utm_campaign=" + data.utm_campaign : "") +
        (data.utm_content !== undefined ? "&utm_content=" + data.utm_content : "") +
        (data.utm_brand !== undefined ? "&utm_brand=" + data.utm_brand : "") +
        (data.referenceId !== undefined ? "&referenceId=" + data.referenceId : "") +
        (data.message !== undefined ? "&message=" + data.message : "") +
        ((data.skin !== undefined) ? "&skin=" + data.skin : "")
}
